module.exports = __webpack_public_path__ + "img/2.7a4879a6.jpg";